import { gql } from "@apollo/client";

/**
 * Query to list detox sessions with filters and pagination
 * Uses dynamic where clause to avoid null value errors
 */
export const LIST_DETOX_SESSIONS = gql`
  query ListDetoxSessions(
    $limit: Int
    $offset: Int
    $where: digital_detox_sessions_bool_exp
    $order_by: [digital_detox_sessions_order_by!]
  ) {
    digital_detox_sessions(
      limit: $limit
      offset: $offset
      where: $where
      order_by: $order_by
    ) {
      id
      start_date
      end_date
      status
      created_at
      updated_at
      is_deleted
      detox_events_aggregate(
        where: { is_deleted: { _eq: false } }
      ) {
        aggregate {
          count
        }
      }
    }
    digital_detox_sessions_aggregate(
      where: $where
    ) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * Query to get a single detox session by ID (without events)
 */
export const GET_DETOX_SESSION_BY_ID = gql`
  query GetDetoxSessionById($id: uuid!) {
    digital_detox_sessions_by_pk(id: $id) {
      id
      start_date
      end_date
      status
      created_at
      updated_at
      is_deleted
    }
  }
`;

export const CREATE_DETOX_SESSION = gql`
  mutation CreateDetoxSession(
    $start_date: date!
    $end_date: date!
  ) {
    insert_digital_detox_sessions_one(
      object: {
        start_date: $start_date
        end_date: $end_date
      }
    ) {
      id
      start_date
      end_date
      status
      created_at
    }
  }
`;

/**
 * Mutation to update a detox session
 * Uses dynamic _set object to avoid null value errors
 */
export const UPDATE_DETOX_SESSION = gql`
  mutation UpdateDetoxSession(
    $pk_columns: digital_detox_sessions_pk_columns_input!
    $set: digital_detox_sessions_set_input
  ) {
    update_digital_detox_sessions_by_pk(
      pk_columns: $pk_columns
      _set: $set
    ) {
      id
      start_date
      end_date
      status
      updated_at
    }
  }
`;

/**
 * Mutation to soft delete a detox session
 */
export const SOFT_DELETE_DETOX_SESSION = gql`
  mutation SoftDeleteDetoxSession($id: uuid!) {
    update_digital_detox_sessions_by_pk(
      pk_columns: { id: $id }
      _set: { is_deleted: true }
    ) {
      id
      is_deleted
    }
  }
`;

/**
 * Query to get events for a specific session
 */
export const GET_DETOX_EVENTS_FOR_SESSION = gql`
  query GetDetoxEventsForSession($session_id: uuid!) {
    detox_events(
      where: {
        session_id: { _eq: $session_id }
        is_deleted: { _eq: false }
      }
      order_by: { created_at: asc }
    ) {
      id
      name
      description
      link
      created_at
      updated_at
    }
  }
`;

/**
 * Mutation to create a detox event
 */
export const CREATE_DETOX_EVENT = gql`
  mutation CreateDetoxEvent(
    $session_id: uuid!
    $name: String!
    $description: String
    $link: String
  ) {
    insert_detox_events_one(
      object: {
        session_id: $session_id
        name: $name
        description: $description
        link: $link
      }
    ) {
      id
      name
      description
      link
      created_at
    }
  }
`;

/**
 * Mutation to update a detox event
 */
export const UPDATE_DETOX_EVENT = gql`
  mutation UpdateDetoxEvent(
    $id: uuid!
    $name: String
    $description: String
    $link: String
  ) {
    update_detox_events_by_pk(
      pk_columns: { id: $id }
      _set: {
        name: $name
        description: $description
        link: $link
      }
    ) {
      id
      name
      description
      link
      updated_at
    }
  }
`;

/**
 * Mutation to soft delete a detox event
 */
export const SOFT_DELETE_DETOX_EVENT = gql`
  mutation SoftDeleteDetoxEvent($id: uuid!) {
    update_detox_events_by_pk(
      pk_columns: { id: $id }
      _set: { is_deleted: true }
    ) {
      id
      is_deleted
    }
  }
`;
